import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Pagination,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import {
  CustomButton,
  OrderAcordion,
} from "../../../components/AtomicDesign/Molecules";
import useOrdersAdmin from "../../../hooks/context/useOrdersAdmin";
import { updatePaymentStatus } from "../../../services/cartService";
import { useEffect, useState } from "react";
import { useBreakpoints } from "../../../hooks/useBreakpoins";
import SearchIcon from "@mui/icons-material/Search";

export function AdminOrders() {
  const {
    ordersAdminDataMemo,
    orderAdminRecords,
    getOrdersAdmin,
    setFilters,
    filters,
  } = useOrdersAdmin();
  const { isMobile } = useBreakpoints();
  const [page, setPage] = useState(1);
  const [text, setText] = useState("");
  const [loadingLine, setLoadingLine] = useState({
    index: null,
    loading: false,
  });

  const getPayInfo = async (orderID, index) => {
    setLoadingLine({ index, loading: true });
    try {
      await updatePaymentStatus({
        orderID: Number(orderID),
      });
      getOrdersAdmin();
    } catch {
    } finally {
      setLoadingLine({ index: null, loading: true });
    }
  };

  const verifyAndCharge = () => {};

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilters((old: any) => ({
      ...old,
      paymentStatus: (event.target as HTMLInputElement).value,
    }));
  };

  const handleChangeOrderStatus = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setFilters((old: any) => ({
      ...old,
      orderStatus: (event.target as HTMLInputElement).value,
    }));
  };

  useEffect(() => {
    setPage(1);
  }, [filters]);

  const cleanSearch = () => {
    setFilters((old: any) => ({
      ...old,
      orderNumber: undefined,
    }));
    setText("");
  };

  return (
    <Box
      display="flex"
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      width={"100%"}
      mt={2}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "flex-start",
          alignItems: isMobile ? "flex-start" : "center",
          gap: isMobile ? 1 : 3,
          pl: 2,
        }}
      >
        <TextField
          sx={{ background: "#FFF", minWidth: isMobile ? "95%" : 250 }}
          label="N° do pedido"
          value={text}
          onChange={(e) => setText(e.target.value)}
          InputProps={{
            endAdornment: (
              <>
                {text && (
                  <CustomButton
                    btnType="delete"
                    onClick={cleanSearch}
                    style={{ marginRight: 5 }}
                  />
                )}
                <CustomButton
                  btnType="search"
                  onClick={() => {
                    setFilters((old: any) => ({
                      ...old,
                      orderNumber: text,
                    }));
                  }}
                >
                  <SearchIcon />
                </CustomButton>
              </>
            ),
          }}
        />

        <FormControl>
          <FormLabel id="demo-radio-buttons-payment-status">
            Status do pagamento
          </FormLabel>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-payment-status"
            defaultValue="all"
            value={filters.paymentStatus}
            name="radio-buttons-group"
            onChange={handleChange}
            sx={{ flexDirection: "row" }}
          >
            <FormControlLabel value="all" control={<Radio />} label="All" />
            <FormControlLabel
              value="rejected"
              control={<Radio />}
              label="Não pago"
            />
            <FormControlLabel
              value="approved"
              control={<Radio />}
              label="Pago"
            />
            <FormControlLabel
              value="in_progress"
              control={<Radio />}
              label="Em processagamento"
            />
            <FormControlLabel
              value="pending"
              control={<Radio />}
              label="Pendente"
            />
          </RadioGroup>
        </FormControl>

        <FormControl>
          <FormLabel id="demo-radio-buttons-payment-status">
            Status do pedido
          </FormLabel>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-payment-status"
            defaultValue="all"
            value={filters.orderStatus}
            name="radio-buttons-group"
            onChange={handleChangeOrderStatus}
            sx={{ flexDirection: "row" }}
          >
            <FormControlLabel value="all" control={<Radio />} label="All" />
            <FormControlLabel
              value="partialWithoutRefund"
              control={<Radio />}
              label="Cancelado parcial sem reembolso"
            />
            <FormControlLabel
              value="totalWithoutRefund"
              control={<Radio />}
              label="Cancelado total sem reembolso"
            />
            <FormControlLabel
              value="totalWithRefund"
              control={<Radio />}
              label="Cancelado total com reembolso"
            />
            <FormControlLabel
              value="partialWithRefund"
              control={<Radio />}
              label="Cancelado parcial com reembolso"
            />
            <FormControlLabel
              value="ordered"
              control={<Radio />}
              label="Pedido criado"
            />
            <FormControlLabel
              value="returnToStock"
              control={<Radio />}
              label="Retornar ao estoque"
            />
            <FormControlLabel
              value="send"
              control={<Radio />}
              label="Enviado"
            />
            <FormControlLabel
              value="separeted"
              control={<Radio />}
              label="Separado"
            />
          </RadioGroup>
        </FormControl>
      </Box>

      <OrderAcordion
        getPayInfo={getPayInfo}
        loadingLine={loadingLine}
        verifyAndCharge={verifyAndCharge}
        orders={ordersAdminDataMemo}
        isAdmin
        getOrders={getOrdersAdmin}
      />
      <Box display={"flex"} justifyContent={"center"} width={"100%"} mt={2}>
        <Pagination
          count={orderAdminRecords}
          page={page}
          defaultPage={1}
          onChange={(_e, page) => {
            setFilters((old) => ({ ...old, offset: page - 1 }));
            setPage(page);
          }}
        />
      </Box>
    </Box>
  );
}
